export const URL = 'https://api.passarela44.com.br'; //'http://localhost:3003' //
export const tokenKey = '@passarela44_user';

export const businessKey = '@passarela44_business';

export const metodosDePagamento = [
    { id: 1, value: 1, label: 'Cartão de Crédito' },
    { id: 2, value: 2, label: 'Dinheiro' }
]

export const quantidadeDeParcelas = [
    { id: 1, value: 1, label: '1 parcela (sem juros)' },
    { id: 2, value: 2, label: '2 parcelas (sem juros)' },
    { id: 3, value: 3, label: '3 parcelas (sem juros)' },
]

export const estadosDoPedido = [
    { id: 1, value: 1, label: 'Aguardando confirmação do pagamento' },
    { id: 2, value: 2, label: 'Pagamento confirmado' },
    { id: 3, value: 3, label: 'Em preparação' },
    { id: 4, value: 4, label: 'Em rota de entrega' },
    { id: 5, value: 5, label: 'Pedido entregue' },
    { id: 6, value: 6, label: 'Cancelado' },
]

export const unidadesDeMedida = [
    { id: 1, value: 1, label: 'Unidade' },
    { id: 2, value: 2, label: 'Litro' },
    { id: 3, value: 3, label: 'Metro' },
    { id: 4, value: 4, label: 'Caixa' },
]

export const retornarEstadosDoPedido = estado => {
    if (estado === 1)
        return 'Aguardando confirmação do pagamento';
    if (estado === 2)
        return 'Pagamento confirmado';
    if (estado === 3)
        return 'Em preparação';
    if (estado === 4)
        return 'Em rota de entrega';
    if (estado === 5)
        return 'Pedido entregue';
    if (estado === 6)
        return 'Cancelado';
    return null;
}